import React from 'react';
import { Box, Stack } from '@mui/material';
import EdgeTypeSelector from '../EdgeTypeSelector';
import EdgeActionButtons from '../EdgeActionButtons';
import FeetInchesInput from '../FeetInchesInputV2';
import { StairEdgeTypes } from '../../context/DeckContext';
import EdgeType from '../../../../../../enums/edgeType';
import { Block, Edge } from '../../../../../../types/shared/blocks';
import { getOppositeEdge } from '../../utils/edgeUtils';

interface StairEdgePopperProps {
	block: Block;
	blockEdge: Edge;
	inputEdge: EdgeType | undefined;
	setInputEdge: (edgeType: EdgeType) => void;
	newDimensions: any;
	onStartHeightChange: (inches: number) => void;
	onEndHeightChange: (inches: number) => void;
	editHeightLocked: boolean;
	onAddLanding: () => void;
	onDropdownOpenChange?: (open: boolean) => void;
}

const StairEdgePopper: React.FC<StairEdgePopperProps> = ({
	block,
	blockEdge,
	inputEdge,
	setInputEdge,
	newDimensions,
	onStartHeightChange,
	onEndHeightChange,
	editHeightLocked,
	onAddLanding,
	onDropdownOpenChange,
}) => {
	const isEdgeDisabled = blockEdge?.type === EdgeType.BLOCK_ATTACHED;

	// Get the edge that's attached to the parent block
	const attachedEdge = block.edges.find(
		(edge) => edge.type === EdgeType.BLOCK_ATTACHED
	);
	const oppositeEdgeLabel = getOppositeEdge(attachedEdge?.label);

	// Show start height input when on the attached edge
	const showStartHeightInput = blockEdge?.type === EdgeType.BLOCK_ATTACHED;

	// Show end height input when on the opposite edge of the attached edge
	const showEndHeightInput = blockEdge?.label === oppositeEdgeLabel;

	// Show "Add Landing" button only on the attached edge or the opposite edge
	const showAddLanding =
		blockEdge?.label === attachedEdge?.label ||
		blockEdge?.label === oppositeEdgeLabel;

	return (
		<Stack spacing={1.25}>
			<EdgeTypeSelector
				edgeTypes={StairEdgeTypes}
				value={inputEdge}
				onChange={setInputEdge}
				disabled={isEdgeDisabled}
				label="Edge Types"
				onDropdownOpenChange={onDropdownOpenChange}
			/>

			{showStartHeightInput && (
				<Box sx={{ position: 'relative' }}>
					<FeetInchesInput
						valueInches={newDimensions?.startHeight || 0}
						labelInches="Start Height"
						onChange={onStartHeightChange}
						locked={editHeightLocked}
					/>
				</Box>
			)}

			{showEndHeightInput && (
				<Box sx={{ position: 'relative' }}>
					<FeetInchesInput
						valueInches={newDimensions?.endHeight || 0}
						labelInches="Landing Height"
						onChange={onEndHeightChange}
						locked={editHeightLocked}
					/>
				</Box>
			)}

			<EdgeActionButtons
				showAddLanding={showAddLanding}
				onAddLanding={onAddLanding}
			/>
		</Stack>
	);
};

export default StairEdgePopper;
